/* eslint-disable new-cap */
/* eslint-disable camelcase */
import { diff_match_patch, Diff, DIFF_INSERT, DIFF_DELETE, DIFF_EQUAL } from 'diff-match-patch';

export enum DIFF_MODE {
    DELETE = DIFF_DELETE,
    EQUAL = DIFF_EQUAL,
    INSERT = DIFF_INSERT,
}

export enum DIFF_COLORS {
    INSERT_BG = '#C6FADD',
    INSERT_TEXT = '#5B7B6D',
    DELETE_BG = '#F6C6C8',
    DELETE_TEXT = '#A90D05',
}

const computeDiff = (before: string, after: string): Diff[] => {
    const dmp = new diff_match_patch();
    const diffs = dmp.diff_main(before, after);
    dmp.diff_cleanupSemantic(diffs);

    return diffs;
};

/**
 * Given an array of diffs; group them by paragraphs and
 * return an array of paragraph-diffs
 */
export const groupParagraphs = (diffs: Diff[]): Diff[][] => {
    const paragraphsDiffs: Diff[][] = [];
    let currentParagraph: Diff[] = [];
    for (const diff of diffs) {
        const [diffMode, text] = diff;
        const chunks = text.split(/\n+/g);
        if (chunks.length === 1) {
            currentParagraph.push(diff);
        } else {
            for (let i = 1; i < chunks.length; i++) {
                currentParagraph.push([diffMode, chunks[i - 1]]);
                paragraphsDiffs.push(currentParagraph);
                currentParagraph = i === chunks.length - 1 ? [[diffMode, chunks[i]]] : [];
            }
        }
    }
    if (currentParagraph.length) paragraphsDiffs.push(currentParagraph);

    return paragraphsDiffs;
};

export default computeDiff;
